import { useSandboxEditor } from "features/editor/Feature";
import { useSession } from "hooks/api/useSession";
import { hasSandboxPermission } from "isomorphic/permission";

export const useCanEditSandboxInfo = () => {
  const project = useSandboxEditor();
  const [session] = useSession();

  if (session.state !== "AUTHENTICATED") {
    return false;
  }

  return hasSandboxPermission(project.authorization, "write_project");
};
